<template>
  <section class="content-width">
    <h2>Experience</h2>

    <div class="sidebar">
      <h3>innov8 immersive studios</h3>
      <div class="job-detail">
        <div class="title">Developer</div>
        <div>June 2021 - Present</div>
      </div>
      <div class="job-detail">
        Redmond, WA - Remote
      </div>
      <div class="job-description">
        Develop interactive experiences using modern technologies. Lead team of developers in executing on projects.
        <ul>
          <li>Full-stack development using Node.js and Vue.js</li>
          <li>Web-based interactive 3D, AR, and VR development</li>
          <li>VR, mobile, desktop game/app development using Unreal Engine</li>
          <li>Architected several client projects</li>
        </ul>
      </div>
    </div>

    <div class="sidebar">
      <h3>Freelance</h3>
      <div class="job-detail">
        <div class="title">Developer</div>
        <div>March 2019 - June 2021</div>
      </div>
      <div class="job-detail">
        <span>Auburn, WA</span>
      </div>
      <div class="job-description">
        Worked for clients on projects ranging from full stack websites to XR experiences.
        <ul>
          <li>Major CMS-backed website for large client through agency</li>
          <li>Web development for restaurants and other small businesses</li>
          <li>Augmented Reality <a href="https://youtu.be/DnSSW7T65tc" target="_blank">experience</a> for an iPad equipped event booth</li>
          <li>Web based <a href="https://actors.bible" target="_blank">virtual show experience</a></li>
          <li>Marketing and promotional websites</li>
          <li>3D Showcase for selecting and exploring computers</li>
          <li>Lead/advisory work for <a href="https://innov8ight.io">innov8ight.io </a></li>
        </ul>
      </div>
    </div>

    <div class="sidebar">
      <h3>Rational Creative</h3>
      <div class="job-detail">
        <div class="title">Developer</div>
        <div>November 2017 - March 2019</div>
      </div>
      <div class="job-detail">
        <span>Seattle, WA</span>
      </div>
      <div class="job-description">
        Worked on web projects including full stack applications, animation heavy interactive pages, and in-browser augmented reality experiences. Wrote clear, reusable, modern code using technologies such as Node.js, Vue.js, and AR.js, among many others.
      </div>
    </div>

    <div class="sidebar">
      <div class="job-detail">
        <div class="title">Developer Intern</div>
        <div>August 2015 - November 2017</div>
        <div>Seattle, WA</div>
      </div>
      <div class="job-description">
        Worked on a social network app for an internal startup, Tryb, described below. Worked on full stack of a major website, leading to conversion from intern to full time employee.
      </div>
    </div>

    <div class="sidebar">
      <h3>Tryb</h3>
      <div class="job-detail">
        <div class="title">Mobile &amp; Full Stack Developer</div>
      </div>
      <div class="job-description">
        Built iOS app, backend, and website for group-based hangout planning platform. Contributed to development of Android app. More info about the social network can be found by visiting the website <a href="https://www.tryb.app/" target="_blank">https://www.tryb.app/</a>.
      </div>
    </div>

    <h2>Education</h2>

    <div class="sidebar">
      <h3>Bachelor of Science in Computer Science &amp; Systems</h3>
      <div class="school-degree">
        <div class="title">University of Washington Tacoma</div>
        <div>September 2014 - December 2016</div>
        <div>Minor: Mathematics</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '@/styles/sizes.scss';

h3 {
  margin: 24px 0 4px;

  @include break-phone {
    margin: 16px 0 4px;
  }
}

.job-detail {

  .title {
    font-weight: bold;
  }
}

.job-description {
  margin: 8px 0 36px;
}

.school-degree {

  .title {
    font-weight: bold;
  }
}
</style>
